<template>
  <div>
    <SectionWrapper>
      <Register :enable-third-party="false" @continue="next" />
    </SectionWrapper>
    <DividerSeparator class="compact light">
      <DecoratedButton
        type="link"
        :route="{ name: pages.AUTH_EMBED_LOGIN }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        ALREADY HAVE AN ACCOUNT?
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import Register from "@/components/partials/auth/Register";

export default {
  name: "auth-embed-register",
  props: {
    registrationData: {
      type: Object,
      default: null
    }
  },
  components: { Register },
  methods: {
    next() {
      this.$emit("continue");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
